<template>
  <div class="custom-modal">
    <p class="title"><b>Keyword:</b> {{ keyword.kw }}</p>
    <keyword-chart
      :close-handler="
        () => {
          toggleShowSingleChart(keyword);
          close();
        }
      "
      :keywords="[keyword]"
    />
  </div>
</template>

<script>
const KeywordChart = () => import('components/main-table/KeywordChart');
export default {
  name: 'KwHistoricalChart',
  props: {
    keyword: {
      type: Object,
      required: true,
    },
    toggleShowSingleChart: {
      type: Function,
      required: true,
    },
  },
  components: { KeywordChart },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~sass/modal';
.custom-modal {
  overflow-y: auto;
  height: 100%;
  padding: 32px 32px 48px;

  p.title {
    font-family: Inter, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 13px;
    font-weight: 500;
    line-height: 15.73px;
    text-align: left;
    margin-bottom: 24px;
    b {
      font-weight: 700;
    }
  }
}

.keyword-chart {
  width: 100%;
}
</style>
